module.exports = __webpack_public_path__ + "img/container-4.74387271.png";